import * as React from 'react';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Translate from '../../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import Button from "@material-ui/core/Button";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import RegionService from '../../../services/regionService';
import Spinner from '../../../common/components/spinner/spinner';
import Snackbar from "../../../common/components/snackbar/snackbar";
import { RegionModel } from '../../../models/region/regionModel';


interface IProps {
  closeAddEditRegionModal: any,
  cancelClick: any,
  isVisible: boolean,
  currentRegion: RegionModel,
  saveClick: any
}

interface IState {
  region: RegionModel,
  validationMessage: string,
  isLoading: boolean,
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '25%'
      }
    },
  },
  palette: {
    primary: blue
  }
})

class RegionAddEditDialog extends React.Component<IProps, IState> {
  snackbar: any;
  regionService = new RegionService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      region: props.currentRegion,
      validationMessage: '',
      isLoading: false
    };
  }

  componentDidMount() {
    var currentRegion = this.props.currentRegion;
    if (!currentRegion.id) {
      currentRegion.isActive = true;
      this.setState({ region: currentRegion });
    }
  }

  handleChange = (key, value) => {
    const region: RegionModel = { ...this.state.region };
    region[key] = value;
    this.setState({ region: { ...region } });
  };

  //TODO: Unite handle change into one method
  handleCheckboxChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const region: RegionModel = { ...this.state.region };
    region[name] = value;
    this.setState({ region: { ...region } });
  }

  isValidAddEditForm() {
    let message = '';

    const { region } = this.state;

    if (!region.name || region.name.trim() === '') {
      message += Translate('Please enter name') + '<br />';
    }

    this.setState({
      validationMessage: message
    });

    return message === '';
  }

  handleSaveButton = (event) => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.props.saveClick(this.state.region);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  public render() {

    const { region, isLoading } = this.state;

    let header = '';

    if (!region.id) {
      header = Translate('NewRegion');
    } else {
      header = Translate('EditRegion');
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
          <Modal.DialogContent>
            {isLoading ? <Spinner /> : null}
            <Snackbar ref={(el) => this.snackbar = el} />
            <div>
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', marginBottom: 20 }}>
                  <div style={{ width: "50%", marginRight: 10 }}>
                    <TextField
                      autoFocus
                      name="name"
                      label={Translate("Name")}
                      type="text"
                      onChange={(e) => this.handleChange('name', e.target['value'])}
                      value={region && region.name ? region.name : ""}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', marginBottom: 10 }}>
                  <div style={{ width: '50%' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="isActive"
                          checked={region.isActive}
                          onChange={(e) => this.handleCheckboxChange(e)}
                          color="primary"
                        />
                      }
                      label={Translate("Active")}
                      style={{ marginLeft: -10 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                {Translate("Cancel")}
              </Button>
              <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained">
                {Translate("Save")}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog >
      </MuiThemeProvider>
    )
  }
}

export default RegionAddEditDialog;